import classNames from "classnames/dedupe";
import React, { forwardRef } from "react";
import SearchInput, {
  ISearchInputProps,
} from "../../../Navigational/Search/SearchInput/SearchInput";

export interface ISearchFormInputProps extends ISearchInputProps {
  /**
   * The custom set of css classes used to style component
   *
   */
  classes?: {
    /** Styles applied to outer 'form' element. */
    root?: string;
  };
}

const SearchFormInput = forwardRef<HTMLInputElement, ISearchFormInputProps>(
  ({ classes, ...inputProps }, ref) => (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label className={classNames("search-container", classes?.root)}>
      <SearchInput ref={ref} {...inputProps} />
    </label>
  ),
);

export default SearchFormInput;
